import {Atom, useAtomValue} from "jotai";
import {Loadable} from "jotai/vanilla/utils/loadable";

/**
 * Retrieves value of reactive Loadable Atom or default value
 * @param loadable Loadable Atom, containing reactive state of the object
 * @param defaultValue A value being returned if Atom is not in "hasData" state
 * @param accessorFn Lambda executed on the value of Atom
 * @returns Atom value in "hasData" state, default value otherwise
 */
export const useLoadableValueOrDefault = <AtomType, DataType = AtomType>(
    loadable: Atom<Loadable<Promise<AtomType>>>,
    defaultValue: DataType,
    accessorFn?: (atomData: AtomType) => DataType,
): DataType => {
    const atomState = useAtomValue(loadable);

    if (atomState.state === "hasData") {
        return accessorFn ? accessorFn(atomState.data) : (atomState.data as DataType);
    } else {
        return defaultValue;
    }
};
